import React from 'react';
import { useTabs } from '@lmt/unicorn-shared/app/features/navigation/operations';
import { TableDotMenu } from '../../common/table/TableDotMenu';
import styles from '../CalendarPage.module.scss';
import { pages } from '@lmt/unicorn-shared/app/constants/sharedRoutes';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';

export const CalendarOptionsButton: React.FC = () => {
  const tabs = useTabs();
  const i18next = useScopedTranslation('calendar.options');
  return (
    <TableDotMenu
      iconClassName={styles.dotMenuIcon}
      className={styles.dotMenu}
      options={[
        {
          title: i18next.t('open_absences_and_holidays'),
          onClick: () => tabs.openTab(pages.absences.link()),
        },
      ]}
    />
  );
};
